// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"754":"NotFoundPage","968":"DetailInfoPage"}[chunkId] + "." + {"754":"ef70a771","968":"e4920bec"}[chunkId] + ".chunk.css";
};